import React from 'react';
import Typography from '@material-ui/core/Typography';

import { DSButton } from '../../../components/Button/Button';
import { useHatUrl } from '../../../helpers/customHooks';
import Paper from '../../../styles/templates/Paper';
import { useProfileStyles } from './styles';

const PasswordReset: React.FC = () => {
  const classes = useProfileStyles();
  const hatUrl = useHatUrl();

  return (
    <Paper>
      <div className={classes.container}>
        <div>
          <Typography variant="subtitle1">Password Reset</Typography>
          <Typography className={classes.subtitle} variant="body2">
            Change your password
          </Typography>
        </div>
        <a href={`https://${hatUrl}/auth/recover-password`}>
          <DSButton className={classes.button}>Reset Password</DSButton>
        </a>
      </div>
    </Paper>
  );
};

export default PasswordReset;
